module.exports = __webpack_public_path__ + "img/alipay.c49d7d04.svg";